import DateUtils from './date';
import Alert from './alert';
import CurrencyUtils from './currency'
import CookieUtils from './cookies'
import IdentityUtils from './identity'

const RemoveFucntionObject = (obj) => {
    let newObject = {};
    Object.keys(obj).map(key => {
      if(typeof obj[key] !== 'function') {
        newObject[key] = obj[key];
      }
    })
    return newObject;
}
  
  
export {
    DateUtils,
    Alert,
    CurrencyUtils,
    CookieUtils,
    RemoveFucntionObject,
    IdentityUtils
}

